  <figure class='highcharts-figure'>
    <div id="compOneMetricChart"></div>
  </figure>
